// Helper class for storage and future session stuff

const deleteCookieByName = (name) => {
    document.cookie = `${name}=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

const getCookieByName = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return null;
};

class Storage {
    get = key => window.localStorage.getItem(key);
    set = (key, value) => window.localStorage.setItem(key, value);
    remove = key => window.localStorage.removeItem(key);

    getCookie = name => getCookieByName(name);
    removeCookie = name => deleteCookieByName(name);
}

// Export as new so it's a singleton
const singleton = new Storage();
export default singleton;
